/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 *
 * When the custom drawer (#pmcd) replaces the Horizon cart drawer, opening the
 * Horizon <theme-drawer> would set a scroll-lock that never gets released
 * (its <dialog>.showModal is stubbed out), freezing the page. So route to the
 * custom drawer whenever it is present.
 */

function cartDrawerReplaced() {
  if (document.getElementById('pmcd')) return true;
  const host = document.getElementById('cart-drawer');
  try {
    return !!(host && getComputedStyle(host).display === 'none');
  } catch (e) {
    return false;
  }
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (cartDrawerReplaced()) {
        if (typeof window.__pmcdShow === 'function') {
          window.__pmcdShow();
          return;
        }
        window.location.href = Theme.routes.cart_url || '/cart';
        return;
      }

      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
